export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7318.d056cfb0.jpg";